import { Props_SnippetParagraph } from "./Paragraph.props";
import { Legacy_CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import React from "react";

export const SnippetParagraph = (props: Props_SnippetParagraph) => {
  const { paragrpahProps, headingProps } = props;

  const titleVisibilityClass = headingProps.visibility.value === 'visible' ? "snippet-paragraph__title" : "snippet-paragraph__title accessible-heading";
  const titleAlignClass = headingProps.align?.value ? ` snippet-paragraph__title--align-${headingProps.align.value}` : '';
  const titleClass = `${titleVisibilityClass}${titleAlignClass}`;
  const paragraphAlignClass = paragrpahProps.align?.value ? ` snippet-paragraph__text--align-${paragrpahProps.align.value}` : '';
  const paragraphBackgroundClass = paragrpahProps.background?.value === 'tan' ? ' snippet-paragraph__container--background' : '';

  return (
    <section className="snippet-paragraph">
      <div className={`snippet-paragraph__container${paragraphBackgroundClass}`}>
        {headingProps && <h2 className={titleClass}>{headingProps.heading.value}</h2>}
        {paragrpahProps && <div className={`snippet-paragraph__text${paragraphAlignClass}`}>{Legacy_CompileMarkdown(paragrpahProps.text.value || "")}</div>}
      </div>
    </section>
  );
};
